import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/Styles/app.css";
import "./registerServiceWorker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import i18n from "./i18n";
import filters from "./filters";
import AOS from "aos";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import InfiniteSlideBar from "vue-infinite-slide-bar";
import AppLayout from "@/layouts/AppLayout.vue";
import ContentLayout from "@/layouts/ContentLayout.vue";
import ImageCropper from "@/components/ImageCropper.vue";

AOS.init();

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.component("InfiniteSlideBar", InfiniteSlideBar);
Vue.component("v-select", vSelect);
Vue.component("AppLayout", AppLayout);
Vue.component("ContentLayout", ContentLayout);
Vue.component("ImageCropper", ImageCropper);

Vue.config.productionTip = false;

new Vue({
  filters,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
